var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactPreferences(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90918 4H15.5455",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.09082H3.90909C3.13755 1.09082 2.39761 1.39731 1.85205 1.94287C1.30649 2.48843 1 3.22837 1 3.99991C1 4.77145 1.30649 5.51139 1.85205 6.05695C2.39761 6.60251 3.13755 6.909 3.90909 6.909H17V22.909H3.90909C3.13755 22.909 2.39761 22.6025 1.85205 22.0569C1.30649 21.5114 1 20.7715 1 19.9999V3.99991",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.618 16.9089C13.8362 17.0543 14.1635 17.2361 14.0908 17.6725C13.951 18.1334 13.6672 18.5374 13.2811 18.8253C12.8951 19.1132 12.4269 19.2699 11.9453 19.2725C10.5271 19.2725 8.78169 18.1452 7.25441 16.618C5.72714 15.0907 4.63623 13.3816 4.63623 11.9634C4.63636 11.4864 4.78781 11.0217 5.06878 10.6361C5.34975 10.2506 5.74577 9.96415 6.19987 9.81795C6.63623 9.74523 6.81805 10.0725 6.9635 10.2907L8.05441 11.927C8.15362 12.0929 8.18627 12.2901 8.14578 12.4791C8.10529 12.668 7.99467 12.8346 7.83623 12.9452C7.3635 13.3089 6.92714 13.4543 8.67259 15.1998C10.418 16.9452 10.5271 16.4725 10.9271 16.0361C11.0378 15.8777 11.2043 15.7671 11.3933 15.7266C11.5822 15.6861 11.7795 15.7187 11.9453 15.818L13.618 16.9089Z",
    stroke: "#F49600",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPreferences);
export default __webpack_public_path__ + "static/media/ContactPreferences.bd5c56889495a64707f93e06d5a007d5.svg";
export { ForwardRef as ReactComponent };